<template>
	<div class="reset-password">
		<v-layout row wrap>
			<v-flex xs12 sm6 md6 class="div-container-description-reset-password hidden-sm-and-down">
				<div class="layout-description-reset">
					<p class="paragrafo-title-reset-password">Redefinir Senha!</p>
					<p class="paragrafo-description-reset-password">
						Insira novamente seu <strong><i>e-mail</i></strong>, o <strong><i>token</i></strong> que você recebeu no seu e-mail
						e cadastre sua nova <strong><i>senha</i></strong>.
					</p>
				</div>
			</v-flex>
			<v-flex xs12 sm6 md6 class="div-container-formulario-reset-password">
				<div class="layout-form-reset">
					<div class="div-description-reset-for-cellphone hidden-md-and-up">
						<p class="paragrafo-title-reset-password">Redefinir Senha!</p>
						<p class="paragrafo-description-reset-password">
							Insira novamente seu <strong><i>e-mail</i></strong>, o <strong><i>token</i></strong> que você recebeu no seu e-mail
							e cadastre sua nova <strong><i>senha</i></strong>.
						</p>
					</div>
					<v-form
						ref="form"
						v-model="valid"
						@submit.prevent="submit"
						lazy-validation
					>
						<v-text-field
							v-model="email"
							:rules="emailRules"
							label="E-mail"
							required
							outline
						></v-text-field>
						<v-text-field
							v-model="token"
							:rules="tokesRules"
							label="Token"
							required
							outline
						></v-text-field>
						<v-text-field
							v-model="password"
							:counter="50"
							:rules="passwordRules"
							label="Nova senha"
							required
							type="password"
							outline
						></v-text-field>
						<v-text-field
							v-model="confirmPassword"
							:counter="50"
							:rules="ConfirmPasswordRules"
							label="Confirmar senha"
							required
							type="password"
							outline
						></v-text-field>
							<div class="div-buttons-reset-password">
								<router-link class="button-back-login-reset" to="/login">
									Voltar
								</router-link>
								<button
									:disabled="
										!valid ||
										email.length == 0 ||
										token.length == 0 ||
										password.length == 0 ||
										confirmPassword.length == 0
									"
									class="button-send-email-reset"
									type="submit"
								>
									Redefinir
								</button>
							</div>
					</v-form>
				</div>
			</v-flex>
		</v-layout>
		<v-dialog v-model="showDialogStatusSuccess" max-width="400" >
				<div class="dialog-success">
						<v-icon size="160" color="#206c39">check_circle</v-icon>
						<h4 class="mb-2">Senha resetada com sucesso!</h4>
						<div class="div-ready-description-dialog">
							<span>
								Agora você já esta pronto para se logar novamente na plataforma.
							</span>
						</div>
						<button
							class="button-dialog-status-success"
							v-on:click="buttonPressionedSuccess"
							>OK
						</button>
				</div>
		</v-dialog>
	</div>
</template>

<script>
import { affiliate_api } from '@/api'

export default {
	name: 'ResetPassword',
	mixins: [affiliate_api],
	data() {
		return {
			valid: false,
			loading: false,
			showDialogStatusSuccess: false,
			email: '',
			token: '',
			password: '',
			confirmPassword: '',
			passwordRules: [
				(v) => !!v || 'Campo requerido',
				(v) =>
					(v !== undefined && v.length >= 6) ||
				'Senha deve ter no mínimo 6 caracteres',
			],
			tokesRules: [(v) => !!v || 'Campo Requerido'],
			emailRules: [
				(v) => !!v || 'E-mail é obrigatório',
				(v) => /.+@.+/.test(v) || 'E-mail deve ser válido',
			],
		}
	},
	computed: {
		ConfirmPasswordRules: function () {
			return [
				(v) => !!v || 'Campo requerido',
				(v) => v === this.password || 'As senhas precisam ser iguais',
			]
		},
	},
	methods: {
		submit: async function() {
			try {

				var reset_password = await this.get_reset_password(
					this.email,
					this.token,
					this.password
				)

				if(reset_password.data.message) {

					this.showDialogStatusSuccess = true

				} else {

					this.$notify({
						type: 'error',
						title: `${reset_password.data.msg}!`,
					})

				}

			} catch (err) {

				this.$notify({
					type: 'error',
					title: 'Ocorrreu um problema, informe a Magafilio!',
				})

			}
		},
		buttonPressionedSuccess: function () {
			this.showDialogStatusSuccess = false
			this.$router.push('/login')
		}
	}
}
</script>

<style>

.reset-password {
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-description-reset-password .layout-description-reset {
	width: 60%;
	padding-left: 20px;
}

.div-container-description-reset-password .layout-description-reset .paragrafo-title-reset-password {
	font-size: 48px;
	line-height: 60px;
	font-weight: 900;
	color: #FFFFFF !important;
}

.div-container-description-reset-password .layout-description-reset p.paragrafo-description-reset-password {
	font-size: 15px;
	line-height: 22px;
	font-weight: 300;
}

.div-container-description-reset-password .layout-description-reset p.paragrafo-description-reset-password strong {
	font-weight: 900;
}

.div-description-reset-for-cellphone p.paragrafo-title-reset-password {
	font-size: 28px;
	line-height: 60px;
	font-weight: 900;
	color: #FFFFFF !important;
	text-align: center;
	margin-bottom: 5px;
}

.div-description-reset-for-cellphone p.paragrafo-description-reset-password {
	font-size: 15px;
	line-height: 22px;
	font-weight: 300;
	text-align: center;
	margin-bottom: 30px;
}

.div-description-reset-for-cellphone p.paragrafo-description-reset-password strong {
	font-weight: 900;
}

.div-container-formulario-reset-password {
	background: #2D2F32;
	box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 30px 12px 20px 12px;
}

.div-container-formulario-reset-password .layout-form-reset {
	width: 85%;
	margin: auto;
}

/* Begin input */

div.layout-form-reset .v-text-field__slot {
	margin: 0px;
}

.div-container-formulario-reset-password .v-label.v-label--active.theme--light.primary--text {
	color: #40DA99 !important;
}

/* End input */

.div-container-formulario-reset-password .div-buttons-reset-password {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10px 0px;
}

.div-container-formulario-reset-password .div-buttons-reset-password button.button-send-email-reset {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 4px 30px;
	color: #2D2F32 !important;
	font-weight: 600;
}

.div-container-formulario-reset-password .div-buttons-reset-password button.button-send-email-reset:hover {
	background: #fff;
	color: #2D2F32 !important;
}

.div-container-formulario-reset-password .div-buttons-reset-password button.button-send-email-reset:disabled {
  opacity: 0.4;
	background: #40DA99;
	color: #2D2F32 !important;
	cursor: not-allowed;
}

.div-container-formulario-reset-password .div-buttons-reset-password .button-back-login-reset {
	background: #2D2F32;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	text-align: center;
	text-decoration: none;
	margin-top: 5px;
	color: #40DA99 !important;
	padding: 4px 35px;
	font-weight: 500;
	margin-right: 35px;
}

.div-container-formulario-reset-password .div-buttons-reset-password .button-back-login-reset:hover {
	background: #fff;
	color: #2D2F32 !important;
}

/* Begin loading circle */

.div-loading-circle-reset-password {
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-loading-circle-reset-password circle.v-progress-circular__overlay{
	color: #40DA99 !important;
}

/* End loading circle */

/* dialog success */

.v-dialog.v-dialog--active {
	background: #2D2F32 !important;
	box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 12px 12px 25px 12px;
}

.dialog-success {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.v-dialog.v-dialog--active .div-ready-description-dialog {
	text-align: center;
	margin: 0px 0px 15px 0px;
}

.v-dialog.v-dialog--active .div-ready-description-dialog span  {
	opacity: 0.7;
}

.button-dialog-status-success {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 4px 30px;
	color: #2D2F32 !important;
	font-weight: 600;
	transition: background 0.2s;
}

.button-dialog-status-success:hover {
	background: #FFF;
}

/* End dialog success */

@media (max-width: 960px) {
	.div-container-formulario-reset-password {
		margin: auto;
	}
}

@media (max-width: 600px) {
	.div-container-formulario-reset-password {
		margin: 0px 20px;
	}
}

</style>
